import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllTopics } from '../firebase/topicsService';
import './Scholars.css';

function Scholars() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const topicsPerPage = 10;

  // دالة لتحويل التاريخ الميلادي إلى هجري
  const formatHijriDate = (timestamp) => {
    if (!timestamp) return '-';
    
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      
      // استخدام Intl.DateTimeFormat للحصول على التاريخ الهجري الدقيق
      const formatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
      
      return formatter.format(date);
    } catch (error) {
      console.error('Error formatting Hijri date:', error);
      return '-';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    loadTopics();
  }, []);

  const loadTopics = async () => {
    setLoading(true);
    try {
      const topicsData = await getAllTopics();
      setTopics(topicsData);
    } catch (error) {
      console.error('Error loading topics:', error);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(topics.length / topicsPerPage);
  const indexOfLastTopic = currentPage * topicsPerPage;
  const indexOfFirstTopic = indexOfLastTopic - topicsPerPage;
  const currentTopics = topics.slice(indexOfFirstTopic, indexOfLastTopic);

  const handleTopicClick = (topicId) => {
    navigate(`/scholars/topic/${topicId}`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="scholars-page">
        <div className="scholars-container">
          <div className="loading">جاري تحميل المواضيع...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="scholars-page">
      <div className="scholars-container">
        <div className="scholars-header">
          <h1 className="scholars-title">من درر السلف والعلماء</h1>
          <div className="title-divider"></div>
          <p className="scholars-subtitle">المواضيع العلمية والفوائد المنتقاة</p>
        </div>

        <div className="topics-table-wrapper">
          <div className="topics-stats">
            <span className="stat-item">📚 إجمالي المواضيع: {topics.length}</span>
          </div>

          <div className="topics-table">
            <div className="table-header">
              <div className="header-cell number-col">#</div>
              <div className="header-cell title-col">عنوان الموضوع</div>
              <div className="header-cell date-col">تاريخ النشر</div>
            </div>

            <div className="table-body">
              {currentTopics.map((topic, index) => (
                <div
                  key={topic.id}
                  className="table-row"
                  onClick={() => handleTopicClick(topic.id)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="cell number-col">{indexOfFirstTopic + index + 1}</div>
                  <div className="cell title-col">
                    <div className="topic-title">{topic.title}</div>
                    <div className="topic-excerpt">
                      {topic.content ? topic.content.substring(0, 100) + '...' : ''}
                    </div>
                  </div>
                  <div className="cell date-col">{formatHijriDate(topic.createdAt)}</div>
                </div>
              ))}
            </div>
          </div>

          {topics.length === 0 && (
            <div className="no-topics">لا توجد مواضيع حالياً</div>
          )}

          {totalPages > 1 && (
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                السابق →
              </button>

              <div className="pagination-numbers">
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    className={`pagination-number ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>

              <button
                className="pagination-btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                ← التالي
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Scholars;
